module.exports = __webpack_public_path__ + "media/images/gifts/sensations/sug_sensorial_8-b6eaef76d216878fcef67dd18f3d1648.jpg";